<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="rbt-conatct-area bg-gradient-11 rbt-section-gap" *ngIf="tokenValid && emptyCart">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center mb--60">
                    <h2 class="title">{{'noCoursesyet' | translate}}</h2>
                    <br><br>
                    <div>
                        <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none" routerLink="/courses">
                            <span class="icon-reverse-wrapper">
                                <span class="btn-text">{{'knowCourses' | translate}}</span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section *ngIf="tokenValid && !emptyCart">
    <div class="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-inner text-center">
                        <h2 class="title">{{'Cart' | translate}}</h2>
                        <ul class="page-list">
                            <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                            <li>
                                <div class="icon-right"><i class="feather-chevron-right"></i></div>
                            </li>
                            <li class="rbt-breadcrumb-item active">{{'Cart' | translate}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-cart-area bg-color-white rbt-section-gap">
        <div class="cart_area">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <form action="#">
                            <div class="cart-table table-responsive mb--60">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th class="pro-thumbnail">{{'CourseThumbnail' | translate}}</th>
                                            <th class="pro-title">{{'title' | translate}}</th>
                                            <th class="pro-price">{{'Price' | translate}}</th>
                                            <th class="pro-remove">{{'delete' | translate}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of cartItems">
                                            <td class="pro-thumbnail"><a><img style="max-height: 110px;min-height: 110px;" [src]="this.baseService.appUrl + item.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';"></a></td>
                                            <td class="pro-title"><a>{{item.courseNameAR}}</a></td>
                                            <td class="pro-price"><span>{{item.price}} {{'SAR' | translate}}</span></td>
                                            <td class="pro-remove" style="cursor: pointer;" routerLink="/courses" (click)="removeFromCart(item.id)"><a ><i class="feather-x"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>

                        <div class="row g-5">
                            <div class="col-lg-6 col-12">
                                <div class="discount-coupon edu-bg-shade">
                                    <div class="section-title text-start">
                                        <h4 class="title mb--30"> {{'DiscountCop' | translate}}</h4>
                                    </div>
                                    <form action="#">
                                        <div class="row">
                                            <div class="col-md-8 col-12 mb--25">
                                                <input type="text" placeholder="{{'DiscountCop' | translate}}">
                                            </div>
                                            <div class="col-md-4 col-12 mb--25">
                                                <button class="rbt-btn btn-gradient hover-transform-none btn-sm w-100">
                                                    <span class="icon-reverse-wrapper">
                                                        <span class="btn-text">{{'Apply the code' | translate}}</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div class="col-lg-6 col-12">
                                <div class="cart-summary">
                                    <div class="cart-summary-wrap">
                                        <div class="section-title text-start">
                                            <h4 class="title mb--30">{{'Total purchases' | translate}}</h4>
                                        </div>
                                        <p>{{'Total purchases' | translate}} <span>{{sumPrice}}</span></p>
                                        <p>{{'Discount' | translate}} <span>0</span></p>
                                        <h2>{{'grandTotal'| translate}} <span>{{sumPrice}}</span></h2>
                                    </div>

                                    <div class="row paymentSelection">
                                        <div class="col-lg-6 col-12">
                                            <div class="cart-summary">
                                                <div class="cart-summary-wrap" (click)="selectDiv('CreditCard')" #CreditCard [class.selected]="selectedDiv  === 'CreditCard'">
                                                    <span>{{'payWithCreditCard' | translate}}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-12">
                                            <div class="cart-summary">
                                                <div class="cart-summary-wrap"  (click)="selectDiv('BankTransfer')" #BankTransfer [class.selected]="selectedDiv  === 'BankTransfer'">
                                                    <span>{{'payWithBankTransfer' | translate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cart-submit-btn-group">
                                        <div class="single-button w-50" *ngIf="selectedDiv === 'CreditCard'">
                                            <button class="rbt-btn btn-gradient hover-transform-none w-100 d-block text-center" (click)="savePayment()">
                                                <span>{{'pay' | translate}}</span>
                                            </button>
                                        </div>

                                        <div class="single-button w-50" *ngIf="selectedDiv === 'BankTransfer' && showLearnyBanlData">
                                            <button class="rbt-btn btn-gradient hover-transform-none w-100 d-block text-center" data-bs-toggle="modal" data-bs-target="#bankInfoModal">
                                                <span>{{'pay' | translate}}</span>
                                            </button>
                                        </div>

                                        <div class="single-button w-50" *ngIf="selectedDiv === 'BankTransfer' && !showLearnyBanlData">
                                            <button class="rbt-btn btn-gradient hover-transform-none w-100 d-block text-center" data-bs-toggle="modal" data-bs-target="#learnyBankInfoModal">
                                                <span>{{'pay' | translate}}</span>
                                            </button>
                                        </div>

                                        <div class="single-button w-50">
                                            <button class="rbt-btn hover-transform-none w-100 d-block text-center btn-border" routerLink="/courses">
                                                <span>{{'back' | translate}}</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="rbt-team-modal modal fade rbt-modal-default" id="learnyBankInfoModal" tabindex="-1" role="dialog" aria-labelledby="learnyBankInfoModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 900px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="rbt-round-btn" data-bs-dismiss="modal" aria-label="Close">
                            <i class="feather-x"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="inner" *ngIf="academySettings?.length === 0" style="text-align: center;">
                            <h3>{{'noBankInformation' | translate}}</h3>
                        </div>
    
                        <div class="inner" *ngIf="academySettings?.length !== 0 && cartItems?.length > 1">
                            <div>
                                <div class="perDataCard">
                                    <div class="rbt-profile-row rbt-default-form row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div class="rbt-form-group">
                                                <label for="bankName">{{'bankName' | translate}}</label>
                                                <span>{{academySettings[0]?.settingValue}}</span>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div class="rbt-form-group">
                                                <label for="bankAccountNo">{{'bankAccountNo' | translate}}</label>
                                                <span>{{academySettings[1]?.settingValue}}</span>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                            <div class="rbt-form-group">
                                                <label for="iban">{{'iban' | translate}}</label>
                                                <span>{{academySettings[2]?.settingValue}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="rbt-team-modal modal fade rbt-modal-default" id="bankInfoModal" tabindex="-1" role="dialog" aria-labelledby="bankInfoModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 900px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="rbt-round-btn" data-bs-dismiss="modal" aria-label="Close" (click)="CloseBankdata()">
                            <i class="feather-x"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="inner" *ngIf="teacherBankInfos?.length === 0" style="text-align: center;">
                            <h3>{{'noBankInformation' | translate}}</h3>
                        </div>
                        <div class="inner" *ngIf="teacherBankInfos?.length !== 0">
                            <div *ngFor="let info of teacherBankInfos">
                                <div class="perDataCard" (click)="selectBank(info.bankAccountNo)" #info.bankAccountNo [class.selected]="selectedBankData  === info.bankAccountNo">
                                    <div class="rbt-profile-row rbt-default-form row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div class="rbt-form-group">
                                                <label for="fullname">{{'fullname' | translate}}</label>
                                                <span>{{info.fullName}}</span>
                                            </div>
                                        </div>
        
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div class="rbt-form-group">
                                                <label for="fullname">{{'bankName' | translate}}</label>
                                                <span>{{info.bankName}}</span>
                                            </div>
                                        </div>
        
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                            <div class="rbt-form-group">
                                                <label for="fullname">{{'bankAccountNo' | translate}}</label>
                                                <span>{{info.bankAccountNo}}</span>
                                            </div>
                                        </div>
        
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 20px;">
                                            <div class="rbt-form-group">
                                                <label for="fullname">{{'iban' | translate}}</label>
                                                <span>{{info.iban}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="cart-submit-btn-group" style="justify-content: center;">
                                <div class="single-button w-50">
                                    <button class="rbt-btn btn-gradient hover-transform-none w-100 d-block text-center" (click)="savePayment()" [disabled]="selectedBankData === null">
                                        <span>{{'pay' | translate}}</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
